import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicItem;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const sizeClasses = {
    small: 'w-[140px] md:w-[160px]',
    medium: 'w-[160px] md:w-[185px]',
    large: 'w-[180px] md:w-[210px]',
  };

  const imageHeights = {
    small: 'h-[196px] md:h-[224px]',
    medium: 'h-[224px] md:h-[259px]',
    large: 'h-[252px] md:h-[294px]',
  };

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className={`${sizeClasses[size]} group cursor-pointer`}
    >
      <div className={`${imageHeights[size]} relative overflow-hidden rounded-lg mb-3`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-1 rounded-md whitespace-nowrap">
            立即阅读
          </span>
        </div>
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-background-900/80 text-foreground-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            已完结
          </span>
        )}
        <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {comic.rating}
        </span>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200 mb-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mb-1">{comic.author}</p>
      <div className="flex items-center gap-2 text-xs text-foreground-400">
        <span>{comic.status}</span>
        <span>·</span>
        <span>{formatViews(comic.views)}阅读</span>
      </div>
    </Link>
  );
}